import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Incentivos } from 'src/app/models/incentivos.model';

@Component({
  selector: 'app-incentivos-normativos',
  templateUrl: './incentivos-normativos.component.html',
  styleUrls: ['./incentivos-normativos.component.css']
})
export class IncentivosNormativosComponent {

  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;



  public rows = [];
  public actualRow;
  public antecedente: Incentivos;
  public form;
  public temp_ant;



  constructor(
    private dialog: MatDialog,

  ) {


    if (!JSON.parse(localStorage.getItem("incentivos"))) {
      localStorage.setItem("incentivos", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("incentivos"));

    }


    this.antecedente = { beneficio: "", condicion: "" };
    this.temp_ant = { beneficio: "", condicion: ""  };

    this.form = new FormGroup({
      beneficio: new FormControl('', [Validators.min(0)]),
      condicion: new FormControl('', [Validators.min(0)])
    })


  }


  add_incentivos() {

    this.actualRow = localStorage.getItem("incentivos");
    this.rows = JSON.parse(this.actualRow);

    if (!this.form.value.beneficio && !this.form.value.condicion) {
      this.dialog.open(this.openModalNODATA);

    } else  {

      this.rows = this.rows.concat({
        beneficio: this.form.value.beneficio,
        condicion: this.form.value.condicion
      })


      localStorage.setItem("incentivos", JSON.stringify(this.rows));
      this.form.reset();

    }


  }
  delete_incentivos(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("incentivos", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("incentivos");
    this.rows = JSON.parse(this.actualRow);
  }

  onChangeSelect(event) {
    let value = event.target.value;
  }

  get_incentivos(id) {
    for (let x = 0; x < this.rows.length; x++) {

      if (id == x) {
        this.temp_ant.beneficio = this.rows[x].beneficio;
        this.temp_ant.condicion = this.rows[x].condicion;

        this.dialog.open(this.openModal);

      }
    }
  }

  cleanData() {
    this.temp_ant = { beneficio: "", condicion: "" };

  }

  saveincentivos() {
    this.dialog.closeAll();
    var id = this.temp_ant.numpermiso;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("incentivos", JSON.stringify(this.rows));


        this.actualRow = localStorage.getItem("incentivos");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          beneficio: this.temp_ant.beneficio,
          condicion: this.temp_ant.condicion

        })
        localStorage.setItem("incentivos", JSON.stringify(this.rows));
        /*   this.temp_ant.reset() */
        this.dialog.closeAll();
      }
    }
  }

  changeStatus(values, element, event) {

    this.rows[element.id].ckeck = values


    localStorage.setItem("docs_checkedOK", "cambiado")
    localStorage.setItem("docs_checked", JSON.stringify(this.rows))

  }
}
